export default "__VITE_ASSET__CP23vCha__"